// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__J6nYf","list":"styles_list__pbhhp","listWrapper":"styles_listWrapper__4ElKj","box":"styles_box__2p4WD"};